// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Field__Component button[data-v-2956df52] {\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n}\n.Field__Component .icon[data-v-2956df52] {\n  color: silver;\n}\n.Field__Component.complete .icon[data-v-2956df52] {\n  color: #00bda5;\n}\n.Field__Component.complete span[data-v-2956df52] {\n  text-decoration: line-through;\n}\n", ""]);
// Exports
module.exports = exports;
